<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar granularity="day" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="xrangeChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import format from "date-fns/format";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null
    };
  },
  created() {
    /*     const phaseLang = this.$lang.charts.phase;
    const energyLang = this.$lang.charts.energy_consumption;
    const durationLang = this.$lang.charts.duration; */
    const runtimeLang = this.$lang.charts.runtime;

    this.chartOptions = {
      phase: this.$lang.charts.phase,
      time: {
        useUTC: false
      },
      chart: {
        type: "xrange",
        zoomType: "x"
      },

      boost: {
        enabled: true,
        useGPUTranslations: true,
        usePreAllocated: true
      },

      title: {
        text: this.$lang.charts.disconnector_timeline
      },
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: {
          second: "%e.%m.%Y  %H:%M:%S"
        }
      },
      yAxis: {
        title: {
          text: ""
        },
        categories: [],
        reversed: true
      },
      tooltip: {
        dateTimeLabelFormats: {
          second: "%e.%m.%Y  %H:%M:%S"
        },
        formatter: function() {
          return (
            "<b>" +
            this.series.yAxis.categories[this.point.y] +
            "</b><br>" +
            "<b>" +
            runtimeLang +
            " </b> " +
            format(this.point.x, "DD/MM/YYYY HH:mm:ss") +
            " - " +
            format(this.point.x2, "DD/MM/YYYY HH:mm:ss ") +
            "<br>"
          );
        }
      },
      plotOptions: {
        xrange: {
          showInLegend: false
          //cursor: "pointer"
        }
      },
      credits: {
        enabled: false
      },
      series: [
        {
          borderColor: "gray",
          pointWidth: 20,
          data: [],
          dataLabels: {
            enabled: true
          }
        }
      ],
      scrollbar: {
        enabled: true,
        liveRedraw: true,
        showFull: false
      }
    };

    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
  },

  methods: {
    onPanelSelect(data) {
      this.$nextTick(() => {
        this.getAPIData(data);
      });
    },

    getRelayNames(selected) {
      return axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/disconnector/settings",
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          names: true
        },
        withCredentials: true
      })
        .then(response => {
          return response.data.data;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code == 610) {
              return {
                R1: {
                  name: this.$lang.charts.relay + " 1"
                },
                R2: {
                  name: this.$lang.charts.relay + " 2"
                },
                R3: {
                  name: this.$lang.charts.relay + " 3"
                },
                R4: {
                  name: this.$lang.charts.relay + " 4"
                }
              };
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    },

    getAPIData(selected) {
      const { chart } = this.$refs.xrangeChart;
      chart.showLoading();
      chart.yAxis[0].setCategories([], false);

      this.getRelayNames(selected).then(relaysName => {
        axios({
          method: "POST",
          url: this.$ENDPOINTS.API_R + "/disconnector/data",
          data: {
            token: getSelectedDeviceToken(selected.device.mac),
            from: selected.date.from,
            to: selected.date.to,
            milliseconds: true
          },
          withCredentials: true
        })
          .then(response => {
            let chartData = [];

            Object.keys(response.data.data).forEach(relay => {
              const relayName = relaysName["R" + relay.split("_")[1]].name;
              let categoryIndex = chart.yAxis[0].categories.findIndex(
                e => e == relayName
              );

              response.data.data[relay].forEach(relayData => {
                if (relayData.state === 1) {
                  if (categoryIndex === -1) {
                    chart.yAxis[0].categories.push(relayName);
                    categoryIndex = chart.yAxis[0].categories.findIndex(
                      e => e == relayName
                    );
                  }

                  chartData.push({
                    x: relayData.start,
                    x2: relayData.end,
                    y: categoryIndex,
                    energy: 0,
                    duration: 0
                  });
                }
              });
            });

            chart.series[0].setData(chartData, false, false, false);
            chart.xAxis[0].setExtremes(null, null, true);
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.code == 610) {
                this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
                chart.series[0].setData([]);
              } else {
                this.$refs.snackbar.notify(
                  this.$lang.messages.api_communication_error
                );
              }
            }
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>